module.exports = __webpack_public_path__ + "img/text06.483bc921.svg";